export default {
    BASE_URL: '/crm/member',
    api: [
        {
            name: 'getBaseInfo',
            desc: '获取基础信息',
            method: 'GET',
            path: '/baseInfo'
        },
        {
            name: 'getIdentityInfo',
            desc: '获取实名信息',
            method: 'GET',
            path: '/getIdentityInfo'
        },
        {
            name: 'updateBaseInfo',
            desc: '更新基础信息',
            method: 'PUT',
            path: 'update'
        },
        {
            name: 'getRealInfo',
            desc: '获取实名信息',
            method: 'GET',
            path: '/realInfo'
        },
        {
            name: 'updateRealInfo',
            desc: '提交实名信息',
            method: 'PUT',
            path: '/idcard/add'
        },
        {
            name: 'saveRealInfo',
            desc: '保存实名信息',
            method: 'PUT',
            path: '/idcard/save'
        },
        {
            name: 'modifyPassword',
            desc: '修改密码',
            method: 'PUT',
            path: '/modifyPassword'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/user/profile.js